import { render, staticRenderFns } from "./NewGuideItemPage.vue?vue&type=template&id=6bafaa96&"
import script from "./NewGuideItemPage.vue?vue&type=script&lang=js&"
export * from "./NewGuideItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports